var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loaded
    ? _c("div", [
        _vm.dataElementPaths.length
          ? _c("div", [
              _c("table", { staticClass: "table table-striped" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", { attrs: { colspan: "5" } }, [
                      _vm._v(" Data Elements in "),
                      _c("em", [_vm._v(_vm._s(_vm.distribution.name))]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", { staticClass: "sticky-header" }, [
                    _c("th", [_vm._v("Path name")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Data Element")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Definition")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Data Type")]),
                    _vm._v(" "),
                    _vm.hasPhysicalDataTypes
                      ? _c("th", [_vm._v("Physical Data Type")])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("th", [_vm._v("Format")]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.ordered(_vm.dataElementPaths), function (dePath) {
                    return _c("tr", { key: dePath.uuid }, [
                      _c(
                        "td",
                        [
                          _c("tt", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(dePath.logicalPath) +
                                "\n                        "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        dePath.deId
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.objectUrl + dePath.deId,
                                  target: "_blank",
                                  title: "Open data element in new tab",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(dePath.deName) +
                                    "\n                        "
                                ),
                              ]
                            )
                          : _c("em", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(dePath.deName) +
                                  "\n                        "
                              ),
                            ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("p", {
                          domProps: { innerHTML: _vm._s(dePath.deDefinition) },
                        }),
                        _vm._v(" "),
                        dePath.specificInfo
                          ? _c("div", [
                              _c("hr"),
                              _vm._v(" "),
                              _c("strong", [_vm._v("Specific Information:")]),
                              _vm._v(" "),
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(dePath.specificInfo),
                                },
                              }),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(dePath.dataType) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.hasPhysicalDataTypes
                        ? _c("td", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(dePath.physicalDataType) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(dePath.format) +
                            "\n                    "
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ])
          : _c("strong", [
              _vm._v(
                " No data elements have been specified for this distribution "
              ),
            ]),
      ])
    : _c("Loading")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }